// src/app/services/auth.service.ts
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { API_BASE_URL } from "../../app.constants";



@Injectable({
  providedIn: "root",
})
export class AuthService {
  private baseUrl = `${API_BASE_URL}/tenant/v1/api/authKeyClock/getToken`; // replace with your API

  constructor(private http: HttpClient) {}

  login(email: string, password: string): Observable<any> {
    const payload = { email, password };
    return this.http.post(`${this.baseUrl}`, payload);
  }
}
